var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContenidoRelevante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.545,
    height: 111.521,
    viewBox: "0 0 111.545 111.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7f6e5d;}.b{fill:#e6e7e8;}.c{fill:#e4c05c;}.d{fill:#a4c2f7;}.e{fill:#d4e1f4;}.f{fill:#f1eaf4;}.g{fill:#e3e7f2;}.h{fill:#fff;}.i{fill:#264ecc;}.j{fill:#7821a0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.497 -781.014)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.355 782.871)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.87,
    cy: 14.87,
    r: 14.87,
    transform: "translate(40.892 9.294)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.576,
    cy: 5.576,
    r: 5.576,
    transform: "translate(50.186 16.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M87.279,817.462v2.788a14.768,14.768,0,0,0,14.869,0v-2.788a6.956,6.956,0,0,0-7.435-6.356,7.947,7.947,0,0,0-5.242,1.877A5.85,5.85,0,0,0,87.279,817.462Z",
    transform: "translate(-38.951 -783.224)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M49.864,782.893H49.53a11.151,11.151,0,0,0-11.153,11.152v27.882H68.116V782.893Z",
    transform: "translate(-38.377 -782.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M50,782.893A11.471,11.471,0,0,1,60.818,794.51v92.472a3.73,3.73,0,0,0,3.718,3.718H120.3a3.728,3.728,0,0,0,3.717-3.718V794.045a11.161,11.161,0,0,0-11.152-11.152Z",
    transform: "translate(-38.514 -782.893)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M55.643,782.893A11.472,11.472,0,0,1,66.461,794.51v92.472a3.729,3.729,0,0,0,3.718,3.718h53.9a3.729,3.729,0,0,0,3.718-3.718V794.045a11.161,11.161,0,0,0-11.152-11.152Z",
    transform: "translate(-38.58 -782.893)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 14.87,
    cy: 14.87,
    r: 14.87,
    transform: "translate(40.892 9.294)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.576,
    cy: 5.576,
    r: 5.576,
    transform: "translate(50.186 16.729)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.328 27.863)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M87.279,817.462v2.788a14.768,14.768,0,0,0,14.869,0v-2.788a6.956,6.956,0,0,0-7.435-6.356,7.947,7.947,0,0,0-5.242,1.877A5.85,5.85,0,0,0,87.279,817.462Z",
    transform: "translate(-87.279 -811.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M96.595,835.512V854.1a3.718,3.718,0,0,1-7.436,0V835.512a3.718,3.718,0,1,1,7.436,0Z",
    transform: "translate(-87.301 -811.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M143.151,828.033V861.49L96.683,852.2v-14.87Z",
    transform: "translate(-87.389 -811.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M147.377,826.108v37.175a3.717,3.717,0,0,1-7.435,0V826.108a3.717,3.717,0,0,1,7.435,0Z",
    transform: "translate(-87.898 -811.22)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M66.435,886.982V790.329A7.458,7.458,0,0,0,59,782.893H53.424c2.045,0,7.435,5.391,7.435,7.436v96.653a3.729,3.729,0,0,0,3.718,3.718h5.576A3.728,3.728,0,0,1,66.435,886.982Z",
    transform: "translate(-38.554 -782.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.106,782.893H49.529a11.151,11.151,0,0,0-11.152,11.152v27.882h5.577V794.045a11.15,11.15,0,0,1,11.152-11.152Z",
    transform: "translate(-38.377 -782.893)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.497 781.014)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M59.066,887.38V816.748h3.718V887.38Z",
    transform: "translate(-36.762 -781.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M60.219,874.861a1.175,1.175,0,0,0,.335.111,2.748,2.748,0,0,0,.371.036,1.948,1.948,0,0,0,1.32-.539,1.833,1.833,0,0,0-.613-3.03,1.859,1.859,0,0,0-2.027,3.03l.279.223A1.456,1.456,0,0,0,60.219,874.861Z",
    transform: "translate(-36.762 -782.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M142.444,820.046a5.581,5.581,0,0,0-5.576,5.576v.36l-7.435,1.617V794.023h0a13.026,13.026,0,0,0-13.01-13.009H49.507c-.015,0-.028.008-.042.009a12.991,12.991,0,0,0-12.968,13V821.9a1.856,1.856,0,0,0,1.859,1.858H58.8v40.892a1.859,1.859,0,1,0,3.718,0V794.49a13.687,13.687,0,0,0-4.105-9.758h58.008a9.3,9.3,0,0,1,9.294,9.294v34.38L97.79,834.477a5.562,5.562,0,0,0-11.108.438H75.53a1.859,1.859,0,1,0,0,3.718H86.682v5.576H75.53a1.859,1.859,0,1,0,0,3.718H86.682V853.5H75.53a1.859,1.859,0,1,0,0,3.718h12.6a5.535,5.535,0,0,0,9.658-3.28l3.761.818v3.447a5.569,5.569,0,0,0,4.374,5.439l9.29,2.06A5.564,5.564,0,0,0,122,860.267V859.2l3.718.807v26.948a1.86,1.86,0,0,1-1.859,1.859H64.378a1.861,1.861,0,0,1-1.859-1.859v-7.435a1.858,1.858,0,1,0-3.717,0v7.435a5.582,5.582,0,0,0,5.576,5.577h59.479a5.583,5.583,0,0,0,5.577-5.577V860.82l7.435,1.617v.36a5.576,5.576,0,0,0,11.152,0V825.622A5.582,5.582,0,0,0,142.444,820.046ZM58.8,794.49v25.556H40.214V794.025a9.3,9.3,0,0,1,9.571-9.294A9.617,9.617,0,0,1,58.8,794.49ZM94.117,853.5a1.859,1.859,0,0,1-3.718,0V834.915a1.859,1.859,0,0,1,3.718,0Zm24.164,6.766a1.852,1.852,0,0,1-.7,1.454,1.794,1.794,0,0,1-1.559.356l-9.282-2.058a1.867,1.867,0,0,1-1.474-1.814v-2.638l13.011,2.828ZM97.835,850.145V838.273l39.033-8.485V858.63ZM144.3,862.8a1.858,1.858,0,1,1-3.717,0V825.622a1.858,1.858,0,1,1,3.717,0Z",
    transform: "translate(-36.497 -781.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M111.331,807.145A16.728,16.728,0,1,0,94.6,823.873,16.727,16.727,0,0,0,111.331,807.145Zm-22.3,11.737v-1.663a5.132,5.132,0,0,1,5.577-4.5,6.08,6.08,0,0,1,4.049,1.445,3.975,3.975,0,0,1,1.527,3.053v1.663a12.846,12.846,0,0,1-11.152,0Zm1.859-13.6A3.718,3.718,0,1,1,94.6,809,3.719,3.719,0,0,1,90.885,805.286Zm-9.294,1.859a13.011,13.011,0,1,1,22.2,9.2,7.753,7.753,0,0,0-2.727-5A8.927,8.927,0,0,0,99.9,810.5a7.436,7.436,0,1,0-10.592-.01,8.079,8.079,0,0,0-3.894,5.856A12.97,12.97,0,0,1,81.592,807.145Z",
    transform: "translate(-36.983 -781.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M75.972,867.486h22.3a1.858,1.858,0,0,0,0-3.717h-22.3a1.858,1.858,0,1,0,0,3.717Z",
    transform: "translate(-36.939 -781.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M75.972,876.89h37.174a1.858,1.858,0,1,0,0-3.717H75.972a1.858,1.858,0,1,0,0,3.717Z",
    transform: "translate(-36.939 -782.097)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.661 820.046)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M143.062,820.51a5.582,5.582,0,0,0-5.577,5.576v.36l-7.435,1.617h0l-5.263,1.144-26.379,5.735a5.562,5.562,0,0,0-11.108.438h-.042V839.1H87.3v5.576h-.042v3.717H87.3v5.577h-.042A6.3,6.3,0,0,0,91.8,859.42a5.5,5.5,0,0,0,6.6-5.016l3.762.818v3.447a5.569,5.569,0,0,0,4.373,5.439l9.291,2.06a5.565,5.565,0,0,0,6.782-5.438v-1.063l2.008.436.231.05,1.478.321h0l8.383,1.823,2.769.6v.36a5.576,5.576,0,0,0,11.152,0V826.086A5.582,5.582,0,0,0,143.062,820.51ZM94.735,853.966a1.859,1.859,0,0,1-3.718,0V835.379a1.859,1.859,0,0,1,3.718,0Zm24.163,6.766a1.848,1.848,0,0,1-.695,1.454,1.8,1.8,0,0,1-1.56.356l-9.281-2.059a1.867,1.867,0,0,1-1.474-1.813v-2.639l13.01,2.828Zm18.587-1.638-39.033-8.485V838.737l39.033-8.486Zm7.436,4.166a1.859,1.859,0,0,1-3.718,0V826.086a1.859,1.859,0,0,1,3.718,0Z",
    transform: "translate(-87.257 -820.51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContenidoRelevante);
export default __webpack_public_path__ + "static/media/contenido_relevante.3ca524c89c4974096ed6107317ee85f3.svg";
export { ForwardRef as ReactComponent };